import AssetLogo from "../../assets/images/Asset_Logo.png";
import { ALL_APPS } from "../../constants/dataConstant";
import ButtonElement from "../../components/ButtonElement";
import MobileBgLeft from "../../assets/images/MobileBg.png";
import MobileBgBottom from "../../assets/images/MobileBgBottom.png";

const MainSectionMobile = () => {

    const handleAppClick = (app: any) => {
        if (app.appName === "Fanpit") {
            return
        } 
        window.open(app.link, "_blank");
    }

    return (
        <div className="w-screen h-screen relative flex justify-center items-center" style={{ height: 'calc(100vh - 50px)' }}>
            <div className="h-full absolute left-0">
                <img src={MobileBgLeft} style={{ height: "100%" }} alt=""/>
            </div>
            <div className="w-full absolute bottom-0">
                <img src={MobileBgBottom} style={{ width: "100%" }} alt=""/>
            </div>
            <div className="w-full h-full flex flex-col justify-center items-center">
                <img src={AssetLogo} className="w-[86.49px] h-[20px]" alt="Asset money logo"/>
                <div className="mt-4 w-[75%] font-inter text-[30px] text-[#F9D3A6] leading-[110%] text-center z-20">
                    <span className="">{`Are you the`}</span>
                    <span className="font-extralight italic">&nbsp;{`biggest`}&nbsp;&nbsp;</span>
                    <span className="">{`fan?`}</span>
                </div>
                <div className="mt-2 w-[60%] font-inter font-light text-[12px] leading-[110%] text-[#F9D3A6] text-center z-20">
                    {`Show the love towards your favourite artist and showcase your fandom.`}
                </div>
                <div className="mt-6 relative w-screen h-[310px]">
                    <div className="w-full h-full absolute bg-[#161616] opacity-70"/>
                    <div className="w-full h-full relative z-10 flex flex-col items-center">
                        <div className="mt-2 font-inter text-[24px] leading-[110%] text-[#F9D3A6] text-center">
                            {`Our Apps`}
                        </div>
                        <div className="flex flex-row overflow-x-scroll h-[310px] w-screen scrollbar-hide">
                            {
                                ALL_APPS.map((app, index) => {
                                    return (
                                        <div key={app.appName} className={`relative flex gap-2 flex-col items-center mt-3 mr-6 ${index === 0 ? "ml-16" : ""}`}>
                                            <div className="font-inter text-[18px] text-[#F9D3A6]">
                                                {app.appName}
                                            </div>
                                            <div className="relative w-[140px] h-[160px] object-contain">
                                                <img
                                                    src={app.image}
                                                    alt={app.appName}
                                                    className={`w-full absolute h-full object-cover ${app.appName === "Fanpit" ? "opacity-20" : ""}`}
                                                    onClick={() => handleAppClick(app)}
                                                />
                                                {
                                                    app.appName === "Fanpit" ? (
                                                        <div className="text-[#F9D3A6] relative top-16 left-4 bottom-0 text-[18px]">
                                                            Coming Soon
                                                        </div>
                                                    )
                                                    : null
                                                }
                                            </div>
                                            {
                                                app.appName !== "Fanpit" ? (
                                                    <ButtonElement
                                                        text={app.appName}
                                                        disabled={app.appName === "Fanpit"}
                                                        clickHandler={() => handleAppClick(app)}
                                                    />
                                                )
                                                : null
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainSectionMobile
